import '../css/App.css';

import CodeUploader from './uploadSystem/CodeUploaderMicropython';
import EventHandler from './eventSystem/EventHandler';
import Event from './eventSystem/Event';
import LibraryManager, { LibrariesOutdated } from './uploadSystem/LibraryManager';
import { NoMicropython } from './uploadSystem/micropython';
import HeaderAppBar from './components/HeaderAppBar';
import MainWindow from './components/MainWindow';
import { useNotifications } from '@toolpad/core/useNotifications';
import React from 'react';

let codeUploader = new CodeUploader()
let libraryUploader = new LibraryManager()
libraryUploader.initializeLibrary()

export default function App(props) {
  const notifications = useNotifications();
  const [progress, setProgress] = React.useState(0);
  let [connected, setConnected] = React.useState(false);
  let [updating, setUpdating] = React.useState(false);
  if (!codeUploader.isSupported()) {
    throw Error("WebUSB is not supported!")
  }


  async function connect() {
    try {
      await codeUploader.connect()
      notifications.show('Device connected', {
        severity: 'info',
        autoHideDuration: 3000
      });
      setConnected(true);

    } catch (e) {
      notifications.show('Connection failed', {
        severity: 'error',
        autoHideDuration: 3000
      });
    }
  }

  async function updateLibraries() {
    setUpdating(true);
    try {
      console.log(codeUploader)
      if (!codeUploader.connected) {
        notifications.show('Device not connected', {
          severity: 'error',
          autoHideDuration: 3000
        });
        return
      }
      notifications.show('Das Update der Libraries wurde gestartet!', {
        severity: 'info',
        autoHideDuration: 3000
      });

      await libraryUploader.checkForBaseLibraries(codeUploader)
      console.log("Uploading program....")
      await libraryUploader.uploadLibraries(codeUploader, (uploaded, total) => {
        setProgress((uploaded / total) * 100)
      })
      notifications.show('Libraries updated successfully!', {
        severity: 'success',
        autoHideDuration: 3000
      });
      setProgress(100)
      await codeUploader.reset()
    } catch (e) {
      if (e instanceof NoMicropython) {
        notifications.show('Kein MicroPython auf dem Gerät gefunden', {
          severity: 'error',
          autoHideDuration: 3000
        });
      } else if (e instanceof LibrariesOutdated) {
        notifications.show('Die Firmware ist veraltet. Bitte installieren Sie die neueste Firmware auf Ihrem Gerät.', {
          severity: 'warning',
          autoHideDuration: 3000
        });
      } else {
        console.log(e)
        notifications.show('Ein unerwarteter Fehler ist aufgetreten!  ', {
          severity: 'info',
          autoHideDuration: 3000
        });
      }
    }
  }
  return (
    <div>
      <HeaderAppBar />
      <MainWindow onConnect={connect} progress={progress} onUpdate={updateLibraries} connected={connected} updating={updating}/>
    </div>
  );
}